import { render, staticRenderFns } from "./SafetyConfirmList.vue?vue&type=template&id=1d755ad0&lang=pug"
import script from "./SafetyConfirmList.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports